export default import.meta.ROLLDOWN_FILE_URL_gI$hOolzRoMGP6j5JCUYkA